import React, { useState } from 'react';
import {
  DataContainer,
  DataItem,
  Placeholder,
  InputComp,
  TrashWrapper,
  Trash,
  Error,
  InputWrapper,
  ErrorIcon,
  Plus,
  PlusContainer
} from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/CVE/styled';

const CWE_VALIDATOR = /^CWE-\d+$/i;

const InputCWE = ({ listData = [], onAdd, onRemove, expanded }) => {
  const [value, setValue] = useState('');
  const [error, setError] = useState(false);
  const isOdd = (index) => index % 2 !== 0;

  const handleAdd = () => {
    const normalized = value.trim().toUpperCase();

    if (!CWE_VALIDATOR.test(normalized)) {
      setError(true);
      return;
    }

    onAdd(normalized);
    setValue('');
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') handleAdd();
  };

  const handleChange = (event) => {
    setError(false);
    setValue(event.target.value);
  };

  return (
    <>
      <InputWrapper>
        <InputComp
          value={ value }
          placeholder="CWE-NNN"
          onChange={ handleChange }
          onKeyPress={ handleKeyPress }
        />
        <PlusContainer>
          <Plus onClick={ handleAdd } />
        </PlusContainer>
        {error && (
          <Error>
            <ErrorIcon />
            CWE not valid
          </Error>
        )}
      </InputWrapper>
      <DataContainer showGradient={ listData.length < 3 } expanded={ expanded }>
        {listData.map((name, index) => (
          <DataItem key={ `cwe_${name}_${index}` } isOdd={ isOdd(index) }>
            <Placeholder
              href={ `https://cwe.mitre.org/data/definitions/${name.replace(/^CWE-/i, '')}.html` }
              target="_blank"
              rel="noopener noreferrer"
            >
              {name}
            </Placeholder>
            <TrashWrapper onClick={ () => onRemove(name) }>
              <Trash />
            </TrashWrapper>
          </DataItem>
        ))}
      </DataContainer>
    </>
  );
};

export default InputCWE;
